import { cva } from '@/styled-system/css';

export const comboboxOptionRecipe = cva({
  base: {
    'display': 'block',
    'paddingBlock': 'tight',
    'paddingInline': 'default',
    'transitionProperty': {
      _motionReduce: 'none',
      _motionSafe: 'background-color',
    },
    'transitionDuration': {
      _motionReduce: '0s',
      _motionSafe: '{durations.200}',
    },
    'transitionTimingFunction': '{easings.ease}',
    'width': '100%',
    'backgroundColor': { base: 'bg.elevated.mediumShadow' },

    '&:has(.c11n_combobox__option-media)': {
      display: 'grid',
      gridTemplate: `
        "media label" auto
        "media meta" auto / auto auto
      `,
      justifyContent: 'start',
      columnGap: 'tighter',
    },

    '& .c11n_highlight': {
      textStyle: 'body-bold',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        cursor: 'pointer',
        backgroundColor: {
          base: 'bg.elevated.mediumShadow',
          _hover: 'bg.action.neutral.alt.hover',
          _active: 'bg.action.neutral.alt.pressed',
        },
      },
    },
    active: {
      true: {},
      false: {},
    },
    selected: {
      true: {
        backgroundColor: { base: 'bg.elevated.mediumShadow' },
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      disabled: false,
      active: true,
      css: {
        backgroundColor: { base: 'bg.action.neutral.alt.hover' },
      },
    },
  ],
});
